const p = (url: string) => `https://images.weserv.nl/?url=${url.replace('https://', '')}&output=webp&q=80&n=-1`;

export const vehiclesForSale = [
  {
    id: 'lamborghini-sterrato',
    brand: 'Lamborghini',
    model: 'Huracán Sterrato MY23',
    year: 2023,
    mileage: '635 km',
    price: 'Consultar',
    images: [
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-01-at-4.24.32-PM-3.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-01-at-4.24.32-PM-2.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-01-at-4.24.32-PM-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-01-at-4.24.32-PM.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-01-at-4.24.31-PM-2.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-01-at-4.24.31-PM-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-01-at-4.24.31-PM.webp')
    ],
    description: 'Lamborghini Huracán Sterrato MY23 - El primer superdeportivo todoterreno de Lamborghini. Solo 635 km recorridos, prácticamente nuevo.',
    features: [
      'Año 2023', 'Solo 635 km', 'Motor V10 de 610 HP',
      'Suspensión elevada para todo terreno', 'Neumáticos especiales Bridgestone',
      'Interior en Alcantara', 'Edición limitada', 'Único dueño'
    ]
  },
  {
    id: 'luxury-vehicle-1',
    brand: 'Vehículo Premium',
    model: 'Modelo Exclusivo',
    year: 2024,
    price: 'USD $1.4M',
    images: [
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-05-at-1.46.57-PM-4.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-05-at-1.46.57-PM-3.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-05-at-1.46.57-PM-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-05-at-1.46.57-PM-2.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-05-at-1.46.57-PM.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-05-at-1.46.57-PM-5.webp')
    ],
    description: 'Vehículo de lujo exclusivo en perfectas condiciones. Una oportunidad única para adquirir un automóvil de colección.',
    features: [
      'Precio: USD $1.4M', 'Condición impecable', 'Mantenimiento completo',
      'Documentación al día', 'Vehículo de colección', 'Edición especial'
    ]
  },
  {
    id: 'audi-q8',
    brand: 'Audi',
    model: 'Q8 S-Line',
    year: 2023,
    mileage: '17,000 km',
    price: '$1,790,000 MXN (precio a tratar)',
    images: [
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-07-at-10.14.19-AM-1-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-07-at-10.14.19-AM-2.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-07-at-10.14.20-AM-2.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-07-at-10.14.20-AM-1-1.webp')
    ],
    description: 'Audi Q8 S-Line 2023 en excelentes condiciones. Único dueño, motor 3.0 con 340 caballos de fuerza.',
    features: [
      'Año 2023', '17,000 km', 'Único dueño', 'Motor 3.0',
      '340 caballos de fuerza', 'Paquete S-Line',
      'Precio a tratar: $1,790,000 MXN', 'Factura original'
    ]
  },
  {
    id: 'harley-davidson',
    brand: 'Harley-Davidson',
    model: 'Modelo Premium',
    price: 'USD $9,000',
    images: [
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-07-at-10.15.48-AM-2.webp')
    ],
    description: 'Harley-Davidson en excelentes condiciones. Perfecta para los amantes de las motocicletas de lujo.',
    features: [
      'Precio: USD $9,000', 'Motor V-Twin', 'Excelente estado',
      'Mantenimiento al día', 'Documentación completa', 'Lista para rodar'
    ]
  }
];
